import {
  getProviderDisplayName,
  removeGroovePrefix,
  slugifyProvider,
} from "utils/providers";

/**
 * Curated provider logos from assets/play365/images/game-providers/provider-logos.
 * Keyed by normalized provider name (lowercase, separators removed).
 * `invert: true` marks dark/black logos that need the `logo--invert` CSS class.
 */
const PROVIDER_LOGOS = {
  "3oaks": { src: require("assets/play365/images/game-providers/provider-logos/3oaks.webp") },
  "7mojo": { src: require("assets/play365/images/game-providers/provider-logos/7mojo.webp") },
  advantplay: { src: require("assets/play365/images/game-providers/provider-logos/advantplay.webp") },
  askmeslot: { src: require("assets/play365/images/game-providers/provider-logos/askmeslot.webp") },
  aviatrix: { src: require("assets/play365/images/game-providers/provider-logos/aviatrix.webp") },
  betsoft: { src: require("assets/play365/images/game-providers/provider-logos/betsoft.webp") },
  betterplatform: { src: require("assets/play365/images/game-providers/provider-logos/better_platform.webp") },
  bgaming: { src: require("assets/play365/images/game-providers/provider-logos/bgaming.webp") },
  bigtimegaming: { src: require("assets/play365/images/game-providers/provider-logos/bigtimegaming.webp") },
  blueprint: { src: require("assets/play365/images/game-providers/provider-logos/blueprint.webp") },
  booming: { src: require("assets/play365/images/game-providers/provider-logos/booming.webp") },
  endorphina: { src: require("assets/play365/images/game-providers/provider-logos/endorphina.webp") },
  evolution: { src: require("assets/play365/images/game-providers/provider-logos/evolution.webp") },
  evoplay: { src: require("assets/play365/images/game-providers/provider-logos/evoplay.webp") },
  hacksaw: { src: require("assets/play365/images/game-providers/provider-logos/hacksaw.webp") },
  iconic21: { src: require("assets/play365/images/game-providers/provider-logos/iconic21.webp") },
  inout: { src: require("assets/play365/images/game-providers/provider-logos/inout_games.webp") },
  inoutgames: { src: require("assets/play365/images/game-providers/provider-logos/inout_games.webp") },
  jdb: { src: require("assets/play365/images/game-providers/provider-logos/jdb.webp") },
  kalamba: { src: require("assets/play365/images/game-providers/provider-logos/kalamba.webp") },
  kingmidas: { src: require("assets/play365/images/game-providers/provider-logos/kingmidas.webp") },
  megafair: { src: require("assets/play365/images/game-providers/provider-logos/megafair.webp") },
  microgaming: { src: require("assets/play365/images/game-providers/provider-logos/microgaming.webp") },
  mrslotty: { src: require("assets/play365/images/game-providers/provider-logos/mrslotty.webp") },
  netent: { src: require("assets/play365/images/game-providers/provider-logos/netent.webp") },
  nolimitcity: { src: require("assets/play365/images/game-providers/provider-logos/nolimitcity.webp") },
  nolimit: { src: require("assets/play365/images/game-providers/provider-logos/nolimitcity.webp") },
  onetouch: { src: require("assets/play365/images/game-providers/provider-logos/onetouch.webp") },
  onlyplay: { src: require("assets/play365/images/game-providers/provider-logos/onlyplay.webp") },
  peterandsons: { src: require("assets/play365/images/game-providers/provider-logos/peterandsons.webp") },
  petersons: { src: require("assets/play365/images/game-providers/provider-logos/peterandsons.webp") },
  pgsoft: { src: require("assets/play365/images/game-providers/provider-logos/pgsoft.webp") },
  platipus: { src: require("assets/play365/images/game-providers/provider-logos/platipus.webp") },
  playson: { src: require("assets/play365/images/game-providers/provider-logos/playson.webp") },
  pragmaticlive: { src: require("assets/play365/images/game-providers/provider-logos/pragmatic_live.webp") },
  pragmaticplaylive: { src: require("assets/play365/images/game-providers/provider-logos/pragmatic_live.webp") },
  pragmatic: { src: require("assets/play365/images/game-providers/provider-logos/pragmatic_play.webp") },
  pragmaticplay: { src: require("assets/play365/images/game-providers/provider-logos/pragmatic_play.webp") },
  pushgaming: { src: require("assets/play365/images/game-providers/provider-logos/pushgaming.webp") },
  redrake: { src: require("assets/play365/images/game-providers/provider-logos/redrake.webp") },
  redtiger: { src: require("assets/play365/images/game-providers/provider-logos/redtiger.webp") },
  rubyplay: { src: require("assets/play365/images/game-providers/provider-logos/rubyplay.webp"), invert: true },
  skywind: { src: require("assets/play365/images/game-providers/provider-logos/skywind.webp") },
  spinomenal: { src: require("assets/play365/images/game-providers/provider-logos/spinomenal.webp") },
  spribe: { src: require("assets/play365/images/game-providers/provider-logos/spribe.webp") },
  turbo: { src: require("assets/play365/images/game-providers/provider-logos/turbo_games.webp") },
  turbogames: { src: require("assets/play365/images/game-providers/provider-logos/turbo_games.webp") },
  vivo: { src: require("assets/play365/images/game-providers/provider-logos/vivo_gaming.webp") },
  vivogaming: { src: require("assets/play365/images/game-providers/provider-logos/vivo_gaming.webp") },
  winfinity: { src: require("assets/play365/images/game-providers/provider-logos/winfinity.webp") },
  yellowbat: { src: require("assets/play365/images/game-providers/provider-logos/yellowbat.webp") },
  yggdrasil: { src: require("assets/play365/images/game-providers/provider-logos/yggdrasil.webp") },
  zeusplay: { src: require("assets/play365/images/game-providers/provider-logos/zeusplay.webp") },
};

const UNIFIED_LOGOS = {
  "betsoft.png": require("assets/play365/images/game-providers/provider-logos-unified/betsoft.png"),
  "bgaming.png": require("assets/play365/images/game-providers/provider-logos-unified/bgaming.png"),
  "apollo_play.png": require("assets/play365/images/game-providers/provider-logos-unified/apollo_play.png"),
  "aviatrix.png": require("assets/play365/images/game-providers/provider-logos-unified/aviatrix.png"),
  "betsolutions.png": require("assets/play365/images/game-providers/provider-logos-unified/betsolutions.png"),
  "caleta_games.png": require("assets/play365/images/game-providers/provider-logos-unified/caleta_games.png"),
  "el_casino.png": require("assets/play365/images/game-providers/provider-logos-unified/el_casino.png"),
  "evolution.png": require("assets/play365/images/game-providers/provider-logos-unified/evolution.png"),
  "ezugi.png": require("assets/play365/images/game-providers/provider-logos-unified/ezugi.png"),
  "flatdog_games.png": require("assets/play365/images/game-providers/provider-logos-unified/flatdog_games.png"),
  "freshdeck.png": require("assets/play365/images/game-providers/provider-logos-unified/freshdeck.png"),
  "golden_race.png": require("assets/play365/images/game-providers/provider-logos-unified/golden_race.png"),
  "iconic21.png": require("assets/play365/images/game-providers/provider-logos-unified/iconic21.png"),
  "inout_games.png": require("assets/play365/images/game-providers/provider-logos-unified/inout_games.png"),
  "jacktop_live.png": require("assets/play365/images/game-providers/provider-logos-unified/jacktop_live.png"),
  "netent.png": require("assets/play365/images/game-providers/provider-logos-unified/netent.png"),
  "netgame.png": require("assets/play365/images/game-providers/provider-logos-unified/netgame.png"),
  "novomatic.png": require("assets/play365/images/game-providers/provider-logos-unified/novomatic.png"),
  "red_eagle.png": require("assets/play365/images/game-providers/provider-logos-unified/red_eagle.png"),
  "sa_gaming.png": require("assets/play365/images/game-providers/provider-logos-unified/sa_gaming.png"),
  "salsa_video_bingo.png": require("assets/play365/images/game-providers/provider-logos-unified/salsa_video_bingo.png"),
  "slotopia.png": require("assets/play365/images/game-providers/provider-logos-unified/slotopia.png"),
  "spinmatic.png": require("assets/play365/images/game-providers/provider-logos-unified/spinmatic.png"),
  "superlotto.png": require("assets/play365/images/game-providers/provider-logos-unified/superlotto.png"),
  "tada_gaming.png": require("assets/play365/images/game-providers/provider-logos-unified/tada_gaming.png"),
  "thunderspin.png": require("assets/play365/images/game-providers/provider-logos-unified/thunderspin.png"),
  "triple_cherry.png": require("assets/play365/images/game-providers/provider-logos-unified/triple_cherry.png"),
  "tvbet.png": require("assets/play365/images/game-providers/provider-logos-unified/tvbet.png"),
  "vibra_gaming.png": require("assets/play365/images/game-providers/provider-logos-unified/vibra_gaming.png"),
  "vivo_gaming.png": require("assets/play365/images/game-providers/provider-logos-unified/vivo_gaming.png"),
  "pragmatic_play.png": require("assets/play365/images/game-providers/provider-logos-unified/pragmatic_play.png"),
  "yggdrasil.png": require("assets/play365/images/game-providers/provider-logos-unified/yggdrasil.png"),
  "zeusplay.png": require("assets/play365/images/game-providers/provider-logos-unified/zeusplay.png"),
};

const uLogo = (file) => ({ src: UNIFIED_LOGOS[file] });

Object.assign(PROVIDER_LOGOS, {
  betsoft: uLogo("betsoft.png"),
  bgaming: uLogo("bgaming.png"),
  apolloplay: uLogo("apollo_play.png"),
  apollogames: uLogo("apollo_play.png"),
  apollo: uLogo("apollo_play.png"),
  aviatrix: uLogo("aviatrix.png"),
  betsolutions: uLogo("betsolutions.png"),
  caletagames: uLogo("caleta_games.png"),
  caleta: uLogo("caleta_games.png"),
  elcasino: uLogo("el_casino.png"),
  ice: uLogo("el_casino.png"),
  evolution: uLogo("evolution.png"),
  evolutiongaming: uLogo("evolution.png"),
  ezugi: uLogo("ezugi.png"),
  flatdoggames: uLogo("flatdog_games.png"),
  flatdog: uLogo("flatdog_games.png"),
  freshdeck: uLogo("freshdeck.png"),
  freshdeckstudios: uLogo("freshdeck.png"),
  goldenrace: uLogo("golden_race.png"),
  iconic21: uLogo("iconic21.png"),
  inoutgames: uLogo("inout_games.png"),
  inout: uLogo("inout_games.png"),
  jacktoplive: uLogo("jacktop_live.png"),
  jacktoplivedealer: uLogo("jacktop_live.png"),
  jacktop: uLogo("jacktop_live.png"),
  netent: uLogo("netent.png"),
  netgame: uLogo("netgame.png"),
  netgames: uLogo("netgame.png"),
  novomatic: uLogo("novomatic.png"),
  redeagle: uLogo("red_eagle.png"),
  sagaming: uLogo("sa_gaming.png"),
  salsavideobingo: uLogo("salsa_video_bingo.png"),
  salsatechnology: uLogo("salsa_video_bingo.png"),
  salsa: uLogo("salsa_video_bingo.png"),
  slotopia: uLogo("slotopia.png"),
  spinmatic: uLogo("spinmatic.png"),
  superlottogames: uLogo("superlotto.png"),
  superlotto: uLogo("superlotto.png"),
  tadagaming: uLogo("tada_gaming.png"),
  tada: uLogo("tada_gaming.png"),
  thunderspin: uLogo("thunderspin.png"),
  triplecherry: uLogo("triple_cherry.png"),
  tvbet: uLogo("tvbet.png"),
  vibragaming: uLogo("vibra_gaming.png"),
  vibra: uLogo("vibra_gaming.png"),
  vivogaming: uLogo("vivo_gaming.png"),
  vivo: uLogo("vivo_gaming.png"),
  pragmaticplay: uLogo("pragmatic_play.png"),
  pragmatic: uLogo("pragmatic_play.png"),
  yggdrasil: uLogo("yggdrasil.png"),
  yggdrasilgaming: uLogo("yggdrasil.png"),
  zeusplay: uLogo("zeusplay.png"),
});

const PRAGMATIC_COLOR = require("assets/play365/images/game-providers/pragmaticexternal.svg").default;
Object.assign(PROVIDER_LOGOS, {
  pragmatic: { src: PRAGMATIC_COLOR },
  pragmaticplay: { src: PRAGMATIC_COLOR },
});

const BRAND_IMAGES = {
  betsoft: require("assets/play365/images/game-providers/betsoft.avif"),
  "betsoft-gaming": require("assets/play365/images/game-providers/betsoft.avif"),
  bgaming: require("assets/play365/images/game-providers/bgaming.avif"),
  "bg-gaming": require("assets/play365/images/game-providers/bgaming.avif"),
  bigtimegaming: require("assets/play365/images/game-providers/bigtimegaming.avif"),
  "big-time-gaming": require("assets/play365/images/game-providers/bigtimegaming.avif"),
  blueprint: require("assets/play365/images/game-providers/blueprint.avif"),
  "blue-print": require("assets/play365/images/game-providers/blueprint.avif"),
  booming: require("assets/play365/images/game-providers/booming.avif"),
  "booming-games": require("assets/play365/images/game-providers/booming.avif"),
  evolution: require("assets/play365/images/game-providers/evolution.avif"),
  "evolution-gaming": require("assets/play365/images/game-providers/evolution.avif"),
  hacksaw: require("assets/play365/images/game-providers/hacksaw.avif"),
  "hacksaw-gaming": require("assets/play365/images/game-providers/hacksaw.avif"),
  microgaming: require("assets/play365/images/game-providers/microgaming.avif"),
  netent: require("assets/play365/images/game-providers/netent.avif"),
  nolimitcity: require("assets/play365/images/game-providers/nolimitcity.avif"),
  "nolimit-city": require("assets/play365/images/game-providers/nolimitcity.avif"),
  "no-limit-city": require("assets/play365/images/game-providers/nolimitcity.avif"),
  onetouch: require("assets/play365/images/game-providers/onetouch.avif"),
  "one-touch": require("assets/play365/images/game-providers/onetouch.avif"),
  peterandsons: require("assets/play365/images/game-providers/peterandsons.avif"),
  "peter-sons": require("assets/play365/images/game-providers/peterandsons.avif"),
  pgsoft: require("assets/play365/images/game-providers/pgsoft.avif"),
  "pg-soft": require("assets/play365/images/game-providers/pgsoft.avif"),
  platipus: require("assets/play365/images/game-providers/platipus.avif"),
  "pragmatic-play": require("assets/play365/images/game-providers/pragmatic.avif"),
  pushgaming: require("assets/play365/images/game-providers/pushgaming.avif"),
  "push-gaming": require("assets/play365/images/game-providers/pushgaming.avif"),
  redrake: require("assets/play365/images/game-providers/redrake.avif"),
  "red-rake": require("assets/play365/images/game-providers/redrake.avif"),
  redtiger: require("assets/play365/images/game-providers/redtiger.avif"),
  "red-tiger": require("assets/play365/images/game-providers/redtiger.avif"),
  skywind: require("assets/play365/images/game-providers/skywind.avif"),
  spinomenal: require("assets/play365/images/game-providers/spinomenal.avif"),
  spribe: require("assets/play365/images/game-providers/spribe.avif"),
  vivogaming: require("assets/play365/images/game-providers/vivogaming.avif"),
  "vivo-gaming": require("assets/play365/images/game-providers/vivogaming.avif"),
  yggdrasil: require("assets/play365/images/game-providers/yggdrasil.avif"),
  "yggdrasil-gaming": require("assets/play365/images/game-providers/yggdrasil.avif"),
  "1x2-gaming": require("assets/play365/images/game-providers/1x2-gaming.svg").default,
  zeusplay: require("assets/play365/images/game-providers/zeusplay.svg").default,
  tada: require("assets/play365/images/game-providers/TaDa-gamming.png"),
  "tada-gaming": require("assets/play365/images/game-providers/TaDa-gamming.png"),
  "tada-gamings": require("assets/play365/images/game-providers/TaDa-gamming.png"),
};

const LOGO_FILE_CLEANUPS = [
  /_nfs_[a-z0-9-]+/gi,
  /\bv\d+$/gi,
  /\bnew\b/gi,
  /\blogo\b/gi,
  /\bfavicon\b/gi,
];

const LOGO_VARIANT_NORMALIZERS = [
  (value) => value,
  (value) => value.replace(/-/g, ""),
  (value) => value.replace(/-(games|gaming|casino|slots|play)$/g, ""),
];

const LOCAL_LOGO_CATALOG = (() => {
  const context = require.context(
    "../assets/play365/images/game-providers",
    true,
    /\.(png|jpe?g|svg|webp|avif)$/i
  );

  return context.keys().map((key) => {
    const rawFileName = key.split("/").pop()?.replace(/\.[^.]+$/, "") || "";
    const cleanedFileName = LOGO_FILE_CLEANUPS.reduce(
      (acc, regex) => acc.replace(regex, ""),
      rawFileName
    )
      .replace(/gamming/gi, "gaming")
      .replace(/gammin/gi, "gaming")
      .replace(/[_\s]+/g, "-")
      .replace(/-+/g, "-")
      .trim();
    const slug = slugifyProvider(cleanedFileName);
    const variants = LOGO_VARIANT_NORMALIZERS.map((normalizer) => normalizer(slug)).filter(Boolean);
    const uniqueVariants = Array.from(new Set(variants));

    return {
      asset: context(key)?.default || context(key),
      slug,
      variants: uniqueVariants,
      tokens: slug.split("-").filter(Boolean),
    };
  });
})();

function normalizeLogoKey(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
}

function findCuratedLogo(provider) {
  const sources = [
    provider?.provider_slug,
    provider?.name,
    getProviderDisplayName(provider),
  ];
  for (const source of sources) {
    if (!source) continue;
    for (const base of [String(source), removeGroovePrefix(String(source))]) {
      const key = normalizeLogoKey(base);
      if (!key) continue;
      if (PROVIDER_LOGOS[key]) return PROVIDER_LOGOS[key];
      const stripped = key.replace(/(gaming|games|studio)$/, "");
      if (stripped.length >= 3 && PROVIDER_LOGOS[stripped]) return PROVIDER_LOGOS[stripped];
    }
  }
  return null;
}

function buildProviderLookupCandidates(provider) {
  const base = [
    provider.provider_slug || "",
    provider.name || "",
    getProviderDisplayName(provider),
  ]
    .map((value) => slugifyProvider(String(value || "")))
    .filter(Boolean);

  const expanded = base.flatMap((value) => {
    const withoutGroove = removeGroovePrefix(value);
    return [
      value,
      withoutGroove,
      value.replace(/-(games|gaming|casino|slots|play)$/g, ""),
      withoutGroove.replace(/-(games|gaming|casino|slots|play)$/g, ""),
      value.replace(/-/g, ""),
      withoutGroove.replace(/-/g, ""),
    ];
  });

  return Array.from(new Set(expanded.filter(Boolean)));
}

function scoreLogoMatch(candidate, logo) {
  let score = 0;
  if (logo.variants.includes(candidate)) score += 100;
  if (logo.slug === candidate) score += 30;
  if (logo.slug.includes(candidate) || candidate.includes(logo.slug)) score += 20;

  const candidateTokens = candidate.split("-").filter(Boolean);
  const overlap = candidateTokens.filter((token) => logo.tokens.includes(token)).length;
  score += overlap * 8;

  return score;
}

function findBestLocalLogo(provider) {
  const candidates = buildProviderLookupCandidates(provider);
  let best = null;
  let bestScore = 0;

  candidates.forEach((candidate) => {
    LOCAL_LOGO_CATALOG.forEach((logo) => {
      const score = scoreLogoMatch(candidate, logo);
      if (score > bestScore) {
        bestScore = score;
        best = logo.asset;
      }
    });
  });

  return bestScore >= 35 ? best : null;
}

export function getProviderInitials(value) {
  if (!value) return "?";
  const words = value.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

/** Resolve curated / legacy local logo for a provider record. */
export function getProviderBrandImage(provider) {
  const curated = findCuratedLogo(provider);
  if (curated) return curated;
  const slug = (provider.provider_slug || slugifyProvider(provider.name || "")).toLowerCase();
  const nameSlug = slugifyProvider(provider.name || "");
  const slugNoGroova = removeGroovePrefix(slug);
  const nameSlugNoGroova = removeGroovePrefix(nameSlug);
  const bestLocalLogo = findBestLocalLogo(provider);
  const src =
    BRAND_IMAGES[slug] ||
    BRAND_IMAGES[nameSlug] ||
    BRAND_IMAGES[slugNoGroova] ||
    BRAND_IMAGES[nameSlugNoGroova] ||
    bestLocalLogo ||
    null;
  return src ? { src } : null;
}

/** Curated/local logo first, then API-provided logo URL. */
export function resolveProviderLogo(provider) {
  const brand = getProviderBrandImage(provider);
  if (brand) return brand;
  if (provider?.logo) return { src: provider.logo };
  return null;
}
